<script>
	export let data;
	export let query;
</script>

<table>
{#each data as item}
	<tr>
	<td>{item.ukrainian}</td>	
	<td>{item.english}</td>
	<td>{item.german}</td>
	</tr>
{/each}
</table>




<style lang="scss">
	@import "../main.scss";

	table {
		width: 100%;
	}
	
</style>